import React from "react";

import styled from "@emotion/styled";

import NewHeadline from "../../../../shared/NewHeadline";

const Container = styled.div`
    min-height: 200px;
`;
const StorefrontUnavailable = () => {
    return (
        <Container>
            <NewHeadline lookLike="2">
                Es ist ein Fehler aufgetreten
            </NewHeadline>
            <p>
                Der Shop steht aktuell nicht zur Verfügung. Bitte versuche es zu
                einem späteren Zeitpunkt erneut.
            </p>
        </Container>
    );
};

export default StorefrontUnavailable;
